import React, { Component } from 'react'
import { Tabs } from 'antd';
import img1 from '../../../static/images/hardware-banner1.png'
import img2 from '../../../static/images/hardware-banner2.png'
import img3 from '../../../static/images/hardware-banner3.png'
import img4 from '../../../static/images/hardware-banner4.png'
import img5 from '../../../static/images/hardware-banner5.png'
import case1 from '../../../static/images/case-1.png'
import product3 from '../../../static/images/product-8.png'


import './index.less';
const { TabPane } = Tabs;
class Hardware extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
        ],
    }
    componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'affiliate-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
            <div style={{ width: '100%' }}>
                 <iframe 
                 title="pos-static"
                 src={`${process.env.PUBLIC_URL}/static/hardware.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container case-container harware-container">
                
            //     <Tabs className="common-block-case-tabs common-block-harware-tabs" tabPosition="top">
            //         <TabPane tab="台式" key="1">
            //             <div className="top-home-carousel">
            //                 <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //             </div>

            //             <div className="common-block-home">
            //                 <div className="common-block-home-tips">商米旗舰店型台式收银机，始终引领行业标准，并获得多项国际设计大奖。适合追求高性能的商户选择</div>
            //                 <div className="common-block-product">
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2s New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性能卓越，助力商户更好的经营成长</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2s LITE New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">更灵活的组合，多场景适用</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性能卓越，助力商户更好的经营成长</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2 PRO (X2)</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">感官觉醒，简而有度</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2s LITE</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">更灵活的组合，多场景适用</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">T2s MINI</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">小巧不占地，功能更齐全</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">D3</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性价比，功能更齐全</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">Swan1</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性价比，功能更齐全</div>
            //                     </div>
            //                 </div>
            //             </div>
            //         </TabPane>
            //         <TabPane tab="移动" key="2">
            //             <div className="top-home-carousel">
            //                 <div className="banner-bg"><img className="banner-img" src={img2} alt="" /></div>
            //                 {/* <div className="mask-top-content">
            //                     <div className="content-pos">
            //                         <div className="content-left-text">
            //                             <div className="banner-top-title">台式</div>
            //                             <div className="banner-top-tips">打通微信+支付宝原生电子会员卡，</div>
            //                             <div className="banner-top-tips">可以轻量快速的切入到门店,同时高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销</div>
                                        
            //                         </div>

            //                     </div>

            //                 </div> */}
            //             </div>

            //             <div className="common-block-home">
            //                 <div className="common-block-home-tips">支持条码扫描，RFID标签识读，非接卡识读等数据采集方式，随时随地记录掌控每个环节，并对庞大的数据信息进行有效的管理</div>
            //                 <div className="common-block-product">
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2Ks New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">匠心升级，定义场内应用新经典</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2H LITE New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性能强劲PDA，更高、更强、更安全</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2s</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">全新一代PDA，专业助力每个场景数组化</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2K</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">自带键盘并支持更多配件</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">牢固耐用的触控式数据终端</div>
            //                     </div>
                            
                                
                                
            //                 </div>
            //             </div>
            //         </TabPane>
            //         <TabPane tab="自助" key="3">
            //             <div className="top-home-carousel">
            //                 <div className="banner-bg"><img className="banner-img" src={img3} alt="" /></div>
            //                 {/* <div className="mask-top-content">
            //                     <div className="content-pos">
            //                         <div className="content-left-text">
            //                             <div className="banner-top-title">台式</div>
            //                             <div className="banner-top-tips">打通微信+支付宝原生电子会员卡，</div>
            //                             <div className="banner-top-tips">可以轻量快速的切入到门店,同时高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销</div>
                                        
            //                         </div>

            //                     </div>

            //                 </div> */}
            //             </div>

            //             <div className="common-block-home">
            //                 <div className="common-block-home-tips">支持条码扫描，RFID标签识读，非接卡识读等数据采集方式，随时随地记录掌控每个环节，并对庞大的数据信息进行有效的管理</div>
            //                 <div className="common-block-product">
            //                     <div className="product-detail harware-product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2Ks New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">匠心升级，定义场内应用新经典</div>
            //                     </div>
            //                     <div className="product-detail harware-product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2H LITE New</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">性能强劲PDA，更高、更强、更安全</div>
            //                     </div>
            //                     <div className="product-detail harware-product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title">L2s</div>
            //                         <div className="product-detail-tips">智能台式终端</div>
            //                         <div className="product-detail-click">全新一代PDA，专业助力每个场景数组化</div>
            //                     </div>



            //                 </div>
            //             </div>
            //         </TabPane>
            //         <TabPane tab="网络" key="4">
            //             <div className="top-home-carousel">
            //                 <div className="banner-bg"><img className="banner-img" src={img4} alt="" /></div>
            //                 {/* <div className="mask-top-content">
            //                     <div className="content-pos">
            //                         <div className="content-left-text">
            //                             <div className="banner-top-title">台式</div>
            //                             <div className="banner-top-tips">打通微信+支付宝原生电子会员卡，</div>
            //                             <div className="banner-top-tips">可以轻量快速的切入到门店,同时高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销</div>
                                        
            //                         </div>

            //                     </div>

            //                 </div> */}
            //             </div>

            //             <div className="common-block-home">
            //                 {/* <div className="common-block-home-tips">商米旗舰店型台式收银机，始终引领行业标准，并获得多项国际设计大奖。适合追求高性能的商户选择</div> */}
            //                 <div className="common-block-product">
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">4G Wi-Fi基站 New</div>
            //                         <div className="product-detail-click">让每家店，网络时刻在线</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">商用路由器</div>
            //                         <div className="product-detail-click">专为商户打造的商用路由器</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">80后厨云打印机 New</div>
            //                         <div className="product-detail-click">全能打印专家，引领打印“云”体验</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">智能云票据打印机</div>
            //                         <div className="product-detail-click">全自动接单打印</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">智能看店摄像机</div>
            //                         <div className="product-detail-click">一个摄像机看全店</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">AI识客摄像机</div>
            //                         <div className="product-detail-click">店铺客流及客群情况实时掌握</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-title"></div>
            //                         <div className="product-detail-tips tips-margin">智能电子价签</div>
            //                         <div className="product-detail-click">实时、准确显示商品最新价格信息</div>
            //                     </div>
                               
            //                 </div>
            //             </div>
            //         </TabPane>
            //         <TabPane tab="配件" key="5">
            //             <div className="top-home-carousel">
            //                 <div className="banner-bg"><img className="banner-img" src={img5} alt="" /></div>
            //                 {/* <div className="mask-top-content">
            //                     <div className="content-pos">
            //                         <div className="content-left-text">
            //                             <div className="banner-top-title">台式</div>
            //                             <div className="banner-top-tips">打通微信+支付宝原生电子会员卡，</div>
            //                             <div className="banner-top-tips">可以轻量快速的切入到门店,同时高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销</div>
                                        
            //                         </div>

            //                     </div>

            //                 </div> */}
            //             </div>

            //             <div className="common-block-home">
            //                 <div className="common-block-home-tips"></div>
            //                 <div className="common-block-product">
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">58热敏票据打印机</div>
            //                         <div className="product-detail-click">可应用在任何需要打印票据的场景</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">小闪扫码盒</div>
            //                         <div className="product-detail-click">即插即用，扫码支付</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">二维扫码枪</div>
            //                         <div className="product-detail-click">扫码快而准，收银效率高</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">收款机充电宝</div>
            //                         <div className="product-detail-click">保障你的经营免受电力烦恼</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">商用89键键盘</div>
            //                         <div className="product-detail-click">小键盘也能“键”步如飞</div>
            //                     </div>
            //                     <div className="product-detail">
            //                         <div className="product-detail-img">
            //                             <img className="img-style" src={product3} alt="" />
            //                         </div>
            //                         <div className="product-detail-tips tips-margin">MINI钱箱</div>
            //                         <div className="product-detail-click">这么装钱，稳了</div>
            //                     </div>
                                
            //                 </div>
            //             </div>
            //         </TabPane>
            //         <TabPane tab="其他" key="6">
                        
            //         </TabPane>
            //     </Tabs>
    
            // </div >
        )
    }
}


export default Hardware